import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36fd0e10&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_pcivgqzi2ggw3w32ihxlyfliwi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fd0e10",
  null
  
)

export default component.exports